import { Component, Input, OnInit } from '@angular/core'
import { AvailabilityType, AssetPhotoType, DecidingFactors, SearchListing, SearchListingStatus, PublicListingEntry } from '../../../../../graphql'

interface PropertyListingSummary {
    photos: AssetPhotoType[]
    city: string,
    countryCode: string,
    title: string,
    decidingFactors: DecidingFactors
}

@Component({
    selector: 'app-property-listing-card',
    templateUrl: './property-listing-card.html'
})
export class PropertyListingCardComponent implements OnInit {
    @Input() publicListing?: PublicListingEntry
    @Input() searchListing?: SearchListing
    @Input() consumerView = false

    listing: PublicListingEntry | SearchListing
    listingSummary : PropertyListingSummary

    ngOnInit(): void {
        const isPublicListing = this.publicListing
        const summary = isPublicListing ? this.publicListing : this.searchListing?.summary

        this.listing = this.publicListing || this.searchListing!
        console.log(this.listing)
        if (summary) {
            this.listingSummary = {
                photos: summary.photos,
                city: summary.city || '',
                countryCode: summary.countryCode || '',
                title: summary.title,
                decidingFactors: summary.decidingFactors
            }
        }
    }

    isAvailable() {
        return this.searchListing?.status === SearchListingStatus.Available
    }

    isRental() {
        return this.searchListing?.availabilityType == AvailabilityType.Rental
    }
}
